import { Button, message, Popover, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { noticeOfBestBiddersActions } from "../../../../config/actions/procument/noticeOfBestBidder/noticeOfBestBidder.actions";
import generatePDF from "../../../../config/services/generatePdf";
import tableButtonActions from "../../../shared/Tables/TableButtonActions";
import TableTitle from "../../../shared/Tables/TableTitle";

const NoticeOfBestBiddersTable = ({
  handleDelete,
  handleRefreshTable,
  handleExportRecords,
  handleOpenAddModal,
  handleOpenEditModal,
  handleViewDetails,
}) => {
  const [deleteId, setDeleteId] = useState("");
  const [filterTable, setfilterTable] = useState(null);
  const {
    noticeOfBestBidders: data,
    noticeOfBestBiddersLoading: loading,
    noticeOfBestBiddersSuccess: success,
    noticeOfBestBiddersError: error,
    deleteNoticeOfBestBiddersLoading: deleteLoading,
    deleteNoticeOfBestBiddersSuccess: deleteSuccess,
    deleteNoticeOfBestBiddersError: deleteError,
    deleteNoticeOfBestBiddersMessage: deleteMessage,
  } = useSelector((state) => state.noticeOfBestBidderState);
  const {
    success: logDetailsSuccess,
    error: logDetailsError,
    records,
  } = useSelector((state) => state.logDetailsState.addLogDetails);
  const dispatch = useDispatch();
  const columns = [
    {
      title: "Notice Of Best Bidder No.",
      key: "rfqno",
      render: (text) => (
        <div>
          <span className="d-md-none">Notice Of Best Bidder No.:</span>{" "}
          {text.id} <br />
          <div className="d-md-none">
            RFQ No.: {text.rfqno} <br />
            <Popover
              className=""
              trigger="click"
              placement="bottom"
              content={() =>
                tableButtonActions(text, {
                  viewDetails,
                  updateRecord,
                  confirmDelete,
                  deleteRecord,
                  deleteLoading,
                  deleteId,
                })
              }
            >
              Actions: <Button type="link">Actions</Button>
            </Popover>
          </div>
        </div>
      ),
    },
    {
      title: "RFQ No.",
      key: "rfqno",
      dataIndex: "rfqno",
      responsive: ["md"],
    },
    {
      title: "Action",
      key: "operation",
      responsive: ["md"],
      render: (text) => (
        <Popover
          trigger="click"
          placement="bottom"
          content={() =>
            tableButtonActions(text, {
              viewDetails,
              updateRecord,
              confirmDelete,
              deleteRecord,
              deleteLoading,
              deleteId,
            })
          }
        >
          <Button>Actions</Button>
        </Popover>
      ),
    },
  ];
  /* Functions */
  const deleteRecord = (e) => setDeleteId(e.target.id);
  const confirmDelete = () => {
    const noticeOfBestBiddersArray = data.filter((e) => e.id !== deleteId);
    handleDelete(deleteId, noticeOfBestBiddersArray);
  };
  const refreshTable = () => {
    handleRefreshTable();
    if (!success && error) message.error(error);
  };
  const updateRecord = (e) => {
    const noticeOfBestBiddersArray = data.filter((el) => el.id === e.target.id);
    dispatch(
      noticeOfBestBiddersActions.editNoticeOfBestBiddersData(
        noticeOfBestBiddersArray[0]
      )
    );
    handleOpenEditModal(true);
  };
  const viewDetails = (e) => handleViewDetails(e.target.id);

  const search = (value) => {
    const filterTable = data.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(value.toLowerCase())
      )
    );
    setfilterTable(filterTable);
  };
  const setfilterTableNull = (e) => {
    if (!e.target.value) setfilterTable(null);
  };

  const showTotal = (total) => `Total: ${total}`;
  const openAddModal = () => {
    handleOpenAddModal(true);
  };
  const exportRecords = () => {
    message.loading("Processing document for export please wait ", 3);
    handleExportRecords();
  };
  const generateRecordsPdf = () => {
    const pdfColumns = ["Notice Of Best Bidder  No.", "RFQ No."];
    let pdfRows = [];
    data?.forEach((record) => {
      const row = [record.id, record.rfqno];
      pdfRows.push(row);
    });
    generatePDF(
      pdfRows,
      pdfColumns,
      `Amani Initiative Notice Of Best Bidder Forms - ${new Date().toLocaleDateString()}`,
      "Amani Initiative Notice Of Best Bidder Forms.pdf"
    );
  };
  /* Use effect */
  useEffect(() => {
    if (logDetailsSuccess && records === "noticeOfBestBidders") {
      message.info("Started download");
      generateRecordsPdf();
    } else if (!logDetailsSuccess && logDetailsError)
      message.error(logDetailsError);
    if (deleteSuccess && deleteMessage) message.success(deleteMessage);
    else if (!deleteSuccess && deleteError) message.error(deleteError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    logDetailsSuccess,
    logDetailsError,
    deleteSuccess,
    deleteMessage,
    deleteError,
  ]);

  return (
    <div>
      <Table
        pagination={{ total: data.length, showSizeChanger: true, showTotal }}
        loading={loading}
        title={() =>
          TableTitle({
            search,
            setfilterTableNull,
            refreshTable,
            exportRecords,
            openAddModal,
          })
        }
        bordered={true}
        dataSource={filterTable === null ? data : filterTable}
        columns={columns}
      />
    </div>
  );
};

export default NoticeOfBestBiddersTable;
